import {
  Card,
  CardContent,
  Grid,
  IconButton,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import { useFieldArray, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import WSTextField from "../../Components/TextBox/WSTextBox";
import WSPhone from "../../Components/Phone/WSPhone";
import WSDateField from "../../Components/DateField/WSDateField";
import WSSelectField from "../../Components/Select/WSSelect";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import WSImageUpload from "../../Components/FileUpload/WSImageUpload";
import WSFileUpload from "../../Components/FileUpload/WSFileUpload";
import WSButton from "../../Components/Button/WSButton";
import config from "../../Config/clientConfig.json"
export const DeliveryChallan: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, setValue, reset } = useForm<any>();
  const navigate = useNavigate();
  const { fields, append, remove, replace } = useFieldArray({
    name: "items",
    control,
  });

  const handleData = async (data: any) => {
    debugger;
  };

  const handleClose = () => {
    navigate("/");
  };

  return (
    <form>
      <Card>
        <CardContent>
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            wrap="nowrap"
          >
            <Grid item>
              <Grid container spacing={2} alignItems="center" wrap="nowrap">
                <Grid item>
                  <Typography fontWeight="bold" variant="h6">
                    Delivery Challan
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* Right side: Close Icon */}
            <Grid item>
              <IconButton onClick={handleClose}>
                <WSIcons.CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={3}>
            <Grid item xs={12} sm={6}>
              <WSSelectField
                rules={{ required: true }}
                control={control}
                id="party"
                {...register("party")}
                name="party"
                label="Party"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Challan No"}
                {...register("challanNo")}
                id="challanNo"
                name="challanNo"
                control={control}
                rules={{ required: false }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSDateField
                id="invoiceDate"
                name="invoiceDate"
                label={"Invoice Date "}
                dateFormat="DD-MM-YYYY"
                denyFuturOrPast="custom"
                control={control}
                rules={{ required: false }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSDateField
                id="dueDate"
                name="dueDate"
                label={"Due Date "}
                dateFormat="DD-MM-YYYY"
                denyFuturOrPast="custom"
                control={control}
                rules={{ required: false }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSSelectField
                rules={{ required: true }}
                control={control}
                id="stateOfSupply"
                {...register("stateOfSupply")}
                name="stateOfSupply"
                label="State Of Supply"
                options={config.stateConfig.staticOptionData}
              />
            </Grid>
            {fields.length > 0 && (
              <Grid item xs={12}>
                <TableContainer component={Paper}>
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell>Item</TableCell>
                        <TableCell>Item Code</TableCell>
                        <TableCell>HSN Code</TableCell>
                        <TableCell>Description</TableCell>
                        <TableCell>QTY</TableCell>
                        <TableCell>Unit</TableCell>
                        <TableCell>Price/Unit</TableCell>
                        <TableCell>Discount</TableCell>
                        <TableCell>Tax</TableCell>
                        <TableCell>Amount</TableCell>
                        <TableCell align="center">Action</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {fields.map((row, index) => (
                        <TableRow key={row.id}>
                         
                          <TableCell>
                            <WSTextField
                              label=""
                              {...register(`items.${index}.item`)}
                              id={`item-${index}`}
                              control={control}
                            />
                          </TableCell>
                          <TableCell>
                            <WSTextField
                              label=""
                              {...register(`items.${index}.itemCode`)}
                              id={`itemCode-${index}`}
                              control={control}
                            />
                          </TableCell>
                          <TableCell>
                            <WSTextField
                              label=""
                              {...register(`items.${index}.hsnCode`)}
                              id={`hsnCode-${index}`}
                              control={control}
                            />
                          </TableCell>
                          <TableCell>
                            <WSTextField
                              label=""
                              {...register(`items.${index}.description`)}
                              id={`description-${index}`}
                              control={control}
                            />
                          </TableCell>
                          <TableCell>
                            <WSTextField
                              label=""
                              {...register(`items.${index}.qty`)}
                              id={`qty-${index}`}
                              control={control}
                            />
                          </TableCell>
                          <TableCell>
                            <WSSelectField
                              label=""
                              rules={{ required: true }}
                              {...register(`items.${index}.unit`)}
                              id={`unit-${index}`}
                              control={control}
                              options={config.unitconfig.staticOptionData}
                            />
                          </TableCell>
                          <TableCell>
                            <WSTextField
                              label=""
                              {...register(`items.${index}.price`)}
                              id={`price-${index}`}
                              control={control}
                            />
                          </TableCell>
                          <TableCell>
                            <WSTextField
                              label=""
                              {...register(`items.${index}.discount`)}
                              id={`discount-${index}`}
                              control={control}
                            />
                          </TableCell>
                          <TableCell>
                            <WSTextField
                              label=""
                              {...register(`items.${index}.tax`)}
                              id={`tax-${index}`}
                              control={control}
                            />
                          </TableCell>
                          <TableCell>
                            <WSTextField
                              label=""
                              {...register(`items.${index}.amount`)}
                              id={`amount-${index}`}
                              control={control}
                            />
                          </TableCell>
                          <TableCell align="center">
                            <IconButton
                              onClick={() => remove(index)}
                              sx={{ color: "red" }}
                            >
                              <WSIcons.DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            )}

            <Grid item xs={12} sx={{ marginLeft: 1 }}>
              <WSButton
                id="addButton"
                label="+ Add"
                size="small"
                onClick={() =>
                  append({
                    productId: "",
                    quantity: "",
                    unit: "",
                    unitPrice: "",
                    total: "",
                  })
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSTextAreaField
                label={"Description"}
                id={"description"}
                name={"description"}
                control={control}
                rules={{ required: false }}
                rows={3}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Total"}
                {...register("total")}
                id="total"
                name="total"
                control={control}
                rules={{ required: false }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSImageUpload
                control={control}
                id="image"
                name="image"
                label="Add image"
                rules={{ required: false }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
        <Grid item>
          <WSButton
            id="share"
            label="Share"
            size="medium"
            variant="outlined"
            color="primary"
            sx={{
              borderRadius: 2,
              border: "1px solid rgba(126, 176, 246, 1)",
              color: "rgba(126, 176, 246, 1)",
              backgroundColor: "#FFFFFF",
            }}
          />
        </Grid>

        <Grid item>
          <WSButton
            id="submit"
            type="submit"
            label="Save"
            size="medium"
            variant="outlined"
            color="primary"
            onClick={handleSubmit(handleData)}
            sx={{
              borderRadius: 2,
              width: "6rem",
              border: "1px solid rgba(126, 176, 246, 1)",
              color: "#FFFFFF",
              backgroundColor: "rgba(126, 176, 246, 1)",
              "&:hover": {
                backgroundColor: "rgba(126, 176, 246, 1)",
              },
            }}
          />
        </Grid>
      </Grid>
    </form>
  );
});
